import { useState } from 'react';
import { CheckMark } from 'assets/images/orders';
import FloatSelectSerial, { IFloatSelectSerialItem } from '../../FloatSelectSerial';
import { IStockReservation } from 'types/stockOrders';
import useStockReservationState from 'state/useStockReservationState';
import './SelectReservationSerialCheckbox.scss';

interface ISelectReservationSerialCheckboxProps {
  isActive: boolean;
  items: IFloatSelectSerialItem[];
  onSuccess: () => void;
  disabled: boolean;
  orderStatus?: string;
  stockAvailableReservationCount: number;
  stockReservation: IStockReservation | null;
  currentSingleSaleId: number | null;
}

const SelectReservationSerialCheckbox = ({
  isActive,
  items,
  onSuccess,
  disabled,
  orderStatus,
  stockAvailableReservationCount,
  stockReservation,
  currentSingleSaleId
}: ISelectReservationSerialCheckboxProps) => {
  const { setCurrentStockReservation, setCurrentSingleSaleId } = useStockReservationState();

  const [isOpen, setIsOpen] = useState(false);
  const isDelivered = orderStatus?.toLowerCase() === 'entregada';
  const emptyStockAvailableReservationCount = stockAvailableReservationCount === 0;
  const disableCheckbox = disabled || isDelivered || (emptyStockAvailableReservationCount && !isActive);
  const showChangeLink = (!emptyStockAvailableReservationCount && isActive && !isDelivered);

  const handleOpenFloatSelectSerial = () => {
    if (disableCheckbox) return;
    setIsOpen(!isOpen);
    setCurrentStockReservation(stockReservation);
    setCurrentSingleSaleId(currentSingleSaleId);
  };
  return (
    <div className={`selectReservationSerialCheckbox ${disableCheckbox ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <div className="selectReservationSerialCheckboxContainer">
        <div className="reservationStockSelect">
          <div className="iconContainer" onClick={handleOpenFloatSelectSerial}>
            <CheckMark role={isActive ? 'active' : ''} />
          </div>
          <div className="textContainer">
            {isActive ? (
              <div className="isActiveTextContainer" onClick={handleOpenFloatSelectSerial}>
                <span className="isActiveText">Unidad reservada</span>
                {showChangeLink && <span className="isActiveTextChangeLink">Cambiar</span>}
              </div>
            ) : (
              'Reservar unidad'
            )}
          </div>
        </div>
      </div>
      {isOpen && <FloatSelectSerial items={items} onSuccess={onSuccess} setIsOpen={setIsOpen} />}
    </div>
  );
};

export default SelectReservationSerialCheckbox;
